import { render, staticRenderFns } from "./ProofOfIncome.vue?vue&type=template&id=6600f9f0"
import script from "./ProofOfIncome.vue?vue&type=script&lang=js"
export * from "./ProofOfIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports